<script lang="ts">
	import { t } from 'svelte-i18n';
	import type { FiltersGroup } from '@app/types/Filters';
	import FiltersGroupComp from './FiltersGroup.svelte';
	import ButtonText from '../../lib/elements/buttons/variants/ButtonText.svelte';
	import { resetFilters } from '@app/components/filters/filters';
	import { getContext } from 'svelte';

	export let filtersGroups: FiltersGroup[];
	export let numberOfResults: number;
	export let ctaLabel: string;

	let projectsContext = getContext('projects');
</script>

<div class="flex flex-wrap md:gap-3 justify-between items-center">
	{#each filtersGroups as filtersGroup}
		{#if filtersGroup.value === 'categories'}
			<div class="grid grid-cols-4 gap-4 w-full">
				{#each filtersGroup.filters as filter}
					<FiltersGroupComp bind:filtersGroup bind:filter />
				{/each}
			</div>
		{:else}
			<div class="flex items-center">
				{#if filtersGroup.label}
					<div class="font-semibold text-xl md:text-base md:pr-2 pr-4 max-w-[150px]">
						{filtersGroup.label}
					</div>
				{/if}
				<div class="flex space-x-3 lg:space-x-4">
					{#each filtersGroup.filters as filter}
						<FiltersGroupComp bind:filtersGroup bind:filter />
					{/each}
				</div>
			</div>
		{/if}
	{/each}
	<div>
		<div class="pb-2">{@html $t(ctaLabel, { values: { n: numberOfResults } })}</div>

		<ButtonText
			props={{ label: $t('projectsPage.eraseFilters'), classNames: 'underline' }}
			on:click={() => {
				resetFilters();
				if (projectsContext) {
					projectsContext.resetTextSearchValue();
				}
			}}
		/>
	</div>
</div>
